import api from 'utils/api'
// import {getApiClient} from 'utils/helperFunctions'
export const getSpecialdeals = async (payload: any) =>
    await api.post('cps/v1/offers/get-specialdeals', payload)
